import type {FC} from 'react';

import * as S from './styles';

type Props = {
  type?: 'chat';
};

export const ConferenceImage: FC<Props> = ({type}) => (
  <S.Container>
    <S.Background />
    {type === 'chat' ? <S.ChatStuff /> : <S.LiveStuff />}
    <S.Table />
  </S.Container>
);
